module.exports = __webpack_public_path__ + "static/media/snow-tire-installation-red.7ffbba97.svg";